"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const Bonus_vue_1 = require("@/client/components/Bonus.vue");
const BoardSpaceTile_vue_1 = require("@/client/components/board/BoardSpaceTile.vue");
const UndergroundToken_vue_1 = require("@/client/components/underworld/UndergroundToken.vue");
const PreferencesManager_1 = require("../utils/PreferencesManager");
const spaces_1 = require("@/common/boards/spaces");
const SpaceType_1 = require("@/common/boards/SpaceType");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'board-space',
    props: {
        space: {
            type: Object,
            required: true,
        },
        text: {
            type: String,
            default: '',
        },
        aresExtension: {
            type: Boolean,
        },
        tileView: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    components: {
        'bonus': Bonus_vue_1.default,
        'board-space-tile': BoardSpaceTile_vue_1.default,
        'underground-token': UndergroundToken_vue_1.default,
    },
    computed: {
        mainClass() {
            let css = 'board-space board-space-' + this.space?.id.toString();
            css += ' board-space-selectable';
            return css;
        },
        showBonus() {
            return this.space.tileType === undefined || this.tileView === 'hide';
        },
        playerColorCss() {
            if (this.space.color === undefined) {
                return '';
            }
            const css = 'board-cube board-cube--' + this.space.color;
            return (0, PreferencesManager_1.getPreferences)().symbol_overlay ? css + ' overlay' : css;
        },
        claimedToken() {
            if (this.space.undergroundResource === undefined) {
                return undefined;
            }
            return { token: this.space.undergroundResource, shelter: false, active: false };
        },
        getSpaceName() {
            return spaces_1.getSpaceName;
        },
        SpaceType() {
            return SpaceType_1.SpaceType;
        },
    },
});
